<nb-select [(selected)]="selected" (selectedChange)="sortBy($event)" size="small" status="primary">
    <nb-select-label *ngIf="selected">
        <nb-icon [icon]="selected.icon"></nb-icon>
        {{ selected.name | translate }}
    </nb-select-label>
    
    <nb-option *ngFor="let sort of sortTypes" [value]="sort">
        <nb-icon [icon]="sort.icon"></nb-icon>
        {{ sort.name | translate }}
        <nb-icon
            class="ml-auto"
            [hidden]="selected?.value !== sort.value"
            [icon]="icon"></nb-icon>
    </nb-option>
</nb-select>